import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalFrostDatesResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/local-frost-dates.response';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { BaseToastComponent } from '../../../@commons/ui-components/toast-popup/base-toast-component';
import { StorageService } from '../../../@commons/@services/front/storage.service';
import { dayMonthName } from '../../../@commons/@services/front/seed-timing.util';

/**
 * « Tes dates de gel » (CJ-04) : ce que la ligne de gel du calendrier résume,
 * avec la marge de sécurité (9 années sur 10) et d'où vient le calcul.
 */
@Component({
  selector: 'vw-frost-dates-toast',
  standalone: true,
  imports: [SharedModule, TranslatePipe],
  templateUrl: './frost-dates-toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FrostDatesToastComponent extends BaseToastComponent {
  @Input() frostDates: LocalFrostDatesResponse | null = null;
  /** Commune de l'adresse (« Grâce-Hollogne ») ; vide, la phrase s'en passe. */
  @Input() city: string | null = null;

  constructor(private storageService: StorageService) {
    super();
  }

  day(mmdd: string | null): string {
    return mmdd ? dayMonthName(mmdd, this.storageService.getCurrentLanguage()) : '';
  }
}
